<template>
  <div class="home-page">
    <div class="home-title" @click="toBlogHome">
      <span class='anim-opacity2'>
        <span class="home-name">{{ title }}</span>
        <br /><br />
        <span class="home-motto"> {{ maxim }}</span>
        <br /><br />
      </span>
    </div>
    <!-- 背景div 动态文字 -->  
    <canvas id="canvas" style="margin-top:-40px"></canvas>
  </div>
</template>

<script>
import jQuery from "jquery"
import CONFIG from '@/config/config.js';
import blogFooter from '@/views/blogFooter.vue';
import mouseClick from "@/plugins/MouseClickEffect.js"

export default {
  name: 'homePage',
  data() {
    return {
      config: {
          vx: 4,	//小球x轴速度,正为右，负为左
          vy: 4,	//小球y轴速度
          height: 2,	//小球高宽，其实为正方形，所以不宜太大
          width: 2,
          count: 200,		//点个数
          color: "121, 162, 185", 	//点颜色
          stroke: "130,255,255", 		//线条颜色
          dist: 6000, 	//点吸附距离
          e_dist: 20000, 	//鼠标吸附加速距离
          max_conn: 10 	//点到点最大连接数
      },
      maxim:CONFIG.MAXIM,
    }
  },
  computed: {
    title: function () {
      let text = CONFIG.TITLE;
      let str = ""
      for(let char of text){
        str += char + " ";
      }
      return str
    }
  },
  methods: {
    initCanvas () {
      let canvas = document.querySelector("#canvas");
      let ctx = canvas.getContext("2d");
      let particles = [];
      let amount = 0;
      let mouse = { x: -9999, y: -9999 };
      let radius = 1;
      const colors = [
        "rgba(255,182,193,0.85)", 
        "rgba(238,130,238,0.75)",
        "rgba(0,191,255,0.75)",
        "rgba(0,255,255,0.75)",
        "rgba(0,255,127,0.75)",
        "rgba(124,252,0,0.75)",
        "rgba(255,69,0,0.85)", 
        "rgba(255,255,0,0.75)", 
        "rgba(255,215,0,0.85)", 
        "rgba(255,140,0,0.75)",
        "rgba(0,255,255,0.75)",
        "rgba(0,255,0,0.85)"
        
      ];
      let headline =  "半 片 叶 の 小 窝";
      let ww = window.innerWidth * 0.2;
      let wh = window.innerHeight * 0.2;

      function Particle(x, y) {
        this.x = Math.random() * ww;
        this.y = Math.random() * wh;
        this.dest = { x: x, y: y };
        this.r = Math.random() * 2 * Math.PI;
        this.vx = (Math.random() - 0.5) * 16;
        this.vy = (Math.random() - 0.5) * 16;
        this.accX = 0;
        this.accY = 0;
        this.friction = 0.935;
        this.color = colors[Math.floor(Math.random() * 64.75)];
      }

      Particle.prototype.render = function() {
        this.accX = (this.dest.x - this.x) / 100;
        this.accY = (this.dest.y - this.y) / 100;
        this.vx += this.accX;
        this.vy += this.accY;
        this.vx *= this.friction;
        this.vy *= this.friction;
        this.x += this.vx;
        this.y += this.vy;

        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
        ctx.fill();

        var a = this.x - mouse.x;
        var b = this.y - mouse.y;

        var distance = Math.sqrt(a * a + b * b);
        if (distance < (radius * 75)) {
          this.accX = (this.x - mouse.x) / 10;
          this.accY = (this.y - mouse.y) / 10;
          this.vx += this.accX;
          this.vy += this.accY;
        }
      }

      function onMouseMove(e) {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        }

        function onTouchMove(e) {

        if (e.touches.length > 0) {

          mouse.x = e.touches[0].clientX;
          mouse.y = e.touches[0].clientY;
        }
      }

      function onTouchEnd(e) {
        mouse.x = -9999;
        mouse.y = -9999;
      }

      function initScene() {
        ww = canvas.width = window.innerWidth;
        wh = canvas.height = window.innerHeight;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = 'bold 8vw "STXihei"';
        ctx.textAlign = "center";
        ctx.fillText(headline, ww / 2, wh * 1.2/ 3);
        var data = ctx.getImageData(0, 0, ww, wh).data;
        ctx.clearRect(0, 0, canvas.width*0.52, canvas.height*0.52);
        ctx.globalCompositeOperation = "source-over";

        particles = [];
        for (var i = 0; i < ww; i += Math.round(ww / 250)) {
          for (var j = 0; j < wh; j += Math.round(ww / 250)) {
            if (data[((i + j * ww) * 4) + 3] > 200) {
              particles.push(new Particle(i, j));
            }
          }
        }
        amount = particles.length;
      }

      function render(a) {
        requestAnimationFrame(render);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < amount; i++) {
          particles[i].render();
        }
      }
      window.addEventListener("resize", initScene);
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("touchmove", onTouchMove);
      window.addEventListener("touchend", onTouchEnd);
      initScene();
      requestAnimationFrame(render)
    },
    toBlogHome(){
      this.$router.push({path:"/blog"})
    },
  },
  mounted(){
    let _this = this;
    _this.initCanvas();
    jQuery(document).ready(mouseClick());
  }
}
</script>

<style lang="stylus" scoped>
.home-page
  top 0
  left 0
  right 0
  bottom 0
  width 100%
  height 100%
  position absolute
  background-size cover
  background-color #fff
  background-image url("../assets/imgs/bg/5.jpg")

.home-title
  position absolute
  top 50%
  left 45%
  text-align center
  cursor pointer

.home-name
  font-size 24px
  color #18FFFF
  font-family 'Microsoft YaHei'

.home-motto
  font-size 18px
  color #CE93D8
  font-family 'Microsoft YaHei'

.anim-opacity2
  animation 2s opacity2 0s infinite
  -webkit-animation 2s opacity2 0s infinite
  -moz-animation 2s opacity2 0s infinite
  @keyframes opacity2
    0%
      opacity 0
    50%
      opacity .8
    100%
      opacity 0
  @-webkit-keyframes opacity2
    0%
      opacity 0
    50%
      opacity .8
    100%
      opacity 0
  @-moz-keyframes opacity2
    0%
      opacity 0
    50%
      opacity .8
    100%
      opacity 0
</style>
